<app-header></app-header>

<div class="signup-container">
  <!-- LEFT PANEL -->
  <div class="left-section">
    <div class="shimmer"></div>
    <div class="pts-wrap">
      <span class="pt pt-1"></span>
      <span class="pt pt-2"></span>
      <span class="pt pt-3"></span>
      <span class="pt pt-4"></span>
      <span class="pt pt-5"></span>
      <span class="pt pt-6"></span>
      <span class="pt pt-7"></span>
      <span class="pt pt-8"></span>
    </div>

    <div class="left-in">
      <div class="mannino-logo">
        <img
          src="../../assets/NEXGEN Logo final for footer.png"
          alt="NexGen Executive Coaching Academy Logo"
          routerLink="/home"
        />
      </div>

      <h1 class="l-h1">It happens.<br><em>Let's get you back in.</em></h1>
      <p class="l-body">Forgotten passwords are easy to fix.<br><strong>Enter your email and we'll send a verification code in seconds.</strong></p>

      <div class="steps">
        <div class="step">
          <div class="sn">1</div>
          <div class="st"><strong>Enter your email address</strong> — the one you used when you enrolled in NEXGEN</div>
        </div>
        <div class="step">
          <div class="sn">2</div>
          <div class="st"><strong>Check your inbox</strong> — a verification code will arrive within a few minutes</div>
        </div>
        <div class="step">
          <div class="sn">3</div>
          <div class="st"><strong>Enter the code and set a new password</strong> — then log straight back into your courses</div>
        </div>
      </div>

      <div class="l-foot">
        Still stuck? We're here to help.<br>
        Email us: <a href="mailto:support@nexgencoaches.com">support&#64;nexgencoaches.com</a>
      </div>
    </div>
  </div>

  <!-- RIGHT PANEL -->
  <div class="right-section">
    <div class="fw">

      <!-- STEP 1: Enter Email -->
      <ng-container *ngIf="step === 1">
        <a routerLink="/login" class="back-link">
          <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" viewBox="0 0 24 24"><path d="M19 12H5M12 5l-7 7 7 7"/></svg>
          Back to Sign In
        </a>

        <div class="fey">Account Recovery</div>
        <h2 class="fh2">Reset your<br><em>password.</em></h2>
        <p class="fsub">Enter the email address linked to your NEXGEN account and we'll send you a verification code immediately.</p>

        <form (ngSubmit)="onForgotPassword()" novalidate>
          <div class="field">
            <label for="email">Your Email Address</label>
            <input
              type="email" id="email" name="email"
              [(ngModel)]="email"
              placeholder="you@example.com"
              autocomplete="email" required
              [class.err]="resetFailed">
          </div>

          <button type="submit" class="btn-submit">Send Verification Code</button>
          <div class="gold-bar"></div>

          <div class="errmsg" [class.on]="resetFailed">
            We could not find an account with that email address. Please check the spelling and try again — or contact us at <strong>support&#64;nexgencoaches.com</strong>.
          </div>
          <div class="successmsg" [class.on]="resetSuccess">
            Verification code sent! Please check your inbox.
          </div>
        </form>

        <div class="help-row" style="margin-top:28px">
          Remembered it? &nbsp;<a routerLink="/login">Log in here</a>
        </div>
      </ng-container>

      <!-- STEP 2: Enter Verification Code -->
      <ng-container *ngIf="step === 2">
        <a class="back-link" (click)="step = 1" style="cursor:pointer;">
          <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" viewBox="0 0 24 24"><path d="M19 12H5M12 5l-7 7 7 7"/></svg>
          Back
        </a>

        <div class="fey">Verify Your Identity</div>
        <h2 class="fh2">Check your<br><em>inbox.</em></h2>
        <p class="fsub">We sent a verification code to <strong>{{ email }}</strong>. Enter it below to continue.</p>

        <form (ngSubmit)="onVerifyCode()" novalidate>
          <div class="field">
            <label for="code">Verification Code</label>
            <input
              type="text" id="code" name="code"
              [(ngModel)]="code"
              placeholder="Enter the code from your email"
              required
              [class.err]="verifyFailed">
          </div>

          <button type="submit" class="btn-submit">Verify Code</button>
          <div class="gold-bar"></div>

          <div class="errmsg" [class.on]="verifyFailed">
            Invalid or expired code. Please check your email and try again.
          </div>
          <div class="successmsg" [class.on]="verifySuccess">
            Code verified successfully! Set your new password.
          </div>
        </form>

        <div class="resend-row">
          Didn't get it? &nbsp;
          <button type="button" (click)="onForgotPassword()">Resend the code</button>
        </div>

        <div class="help-row" style="margin-top:20px">
          Still having trouble? &nbsp;<a href="mailto:support@nexgencoaches.com">Contact Support</a>
        </div>
      </ng-container>

      <!-- STEP 3: Reset Password -->
      <ng-container *ngIf="step === 3">
        <a class="back-link" (click)="step = 2" style="cursor:pointer;">
          <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" viewBox="0 0 24 24"><path d="M19 12H5M12 5l-7 7 7 7"/></svg>
          Back
        </a>

        <div class="fey">Almost There</div>
        <h2 class="fh2">Set your new<br><em>password.</em></h2>
        <p class="fsub">Choose a strong, secure password to protect your NEXGEN account.</p>

        <form (ngSubmit)="onResetPassword()" novalidate>
          <div class="field">
            <label for="newPassword">New Password</label>
            <input
              type="password" id="newPassword" name="newPassword"
              [(ngModel)]="newPassword"
              placeholder="Enter your new password"
              required
              (input)="checkPasswordStrength()">
          </div>

          <!-- Password Rules -->
          <div class="password-rules">
            <div class="rule" [class.valid]="hasUppercase">
              <span class="rule-icon">{{ hasUppercase ? '✔' : '○' }}</span> Uppercase letter
            </div>
            <div class="rule" [class.valid]="hasLowercase">
              <span class="rule-icon">{{ hasLowercase ? '✔' : '○' }}</span> Lowercase letter
            </div>
            <div class="rule" [class.valid]="hasNumber">
              <span class="rule-icon">{{ hasNumber ? '✔' : '○' }}</span> Number
            </div>
            <div class="rule" [class.valid]="hasSpecialChar">
              <span class="rule-icon">{{ hasSpecialChar ? '✔' : '○' }}</span> Special character
            </div>
            <div class="rule" [class.valid]="hasMinLength">
              <span class="rule-icon">{{ hasMinLength ? '✔' : '○' }}</span> At least 8 characters
            </div>
          </div>

          <button type="submit" class="btn-submit" style="margin-top: 24px;">Reset Password</button>
          <div class="gold-bar"></div>

          <div class="errmsg" [class.on]="resetPwdFailed">
            Password reset failed. Please try again or contact support.
          </div>
          <div class="successmsg" [class.on]="resetPwdSuccess">
            Password reset successfully! Redirecting you to login…
          </div>
        </form>
      </ng-container>

    </div>
  </div>
</div>

<app-bottomside></app-bottomside>